import { createAction } from '@reduxjs/toolkit';

/**
 * A filing of `projectId` was sent, deleted or created here, which can change
 * whether the project belongs in the unsent-filings source of the
 * Verottajailmoitettavat list cached for the employer `cacheKey`.
 *
 * `hasUnsentFilings` says whether the project still has an unsent filing in
 * the months that source looks at: false drops the project from the cached
 * source at once; true and null (not known) leave the ids alone, since only
 * the API knows whether a project belongs on the list at all. Either way the
 * source goes stale, so the list asks the API again the next time it loads.
 */
export const unsentFilingsOfProjectChanged = createAction(
  'projects/unsentFilingsOfProjectChanged'
);
